/** ----------------------------------------
     State
 ---------------------------------------- */

const state = () => {
    return {
        data: [
            {
                title: {
                    eng: 'Frontend-Developer',
                    nl: 'Frontend-Developer'
                },
                office: 'Den Haag',
                type: 'Open application',
                link: 'https://jobs.vruchtvlees.com/front-end-developer',
            },
            {
                title: {
                    eng: 'UX Designer',
                    nl: 'UX Designer',
                },
                office: 'Den Haag',
                type: 'Fulltime',
                link: 'https://jobs.vruchtvlees.com/ux-visual-designer'
            },
            {
                title: {
                    eng: 'Backend-Developer',
                    nl: 'Backend-Developer',
                },
                office: 'Den Haag',
                type: 'Fulltime',
                link: 'https://jobs.vruchtvlees.com/back-end-developer'
            },
            {
                title: {
                    eng: 'Internschip',
                    nl: 'Stage'
                },
                office: 'Den Haag',
                type: 'Fulltime',
                link: 'https://jobs.vruchtvlees.com/internship-stage'
            }
        ]
    }
};

/** ----------------------------------------
    Export State
 ---------------------------------------- */

export default state;